export default {
    parts: [],
    baseStyle: (props) => ({
        wrapper: {
            marginTop: { base: 6, lg: 8 },
            marginBottom: { base: 6, lg: 8 }
        },
        title: {
            fontSize: { base: 'xl', lg: '32px' },
            lineHeight: { base: '100%', lg: '34px' },
            marginTop: { base: 6, lg: 8 },
            marginBottom: { base: 6, lg: 8 },
            // Padding to align with page content when carousel bleeds
            // Only add padding when container is full viewport (no existing container padding)
            paddingLeft: {
                base: props?.isAlreadyFullViewport ? 4 : 0,
                lg: props?.isAlreadyFullViewport ? 6 : 0
            },
            paddingRight: {
                base: props?.isAlreadyFullViewport ? 4 : 0,
                lg: props?.isAlreadyFullViewport ? 6 : 0
            }
        },
        tabList: {
            border: 0,
            // Padding to align with page content when carousel bleeds
            // Only add padding when container is full viewport (no existing container padding)
            paddingLeft: {
                base: props?.isAlreadyFullViewport ? 4 : 0,
                lg: props?.isAlreadyFullViewport ? 6 : 0
            },
            paddingRight: {
                base: props?.isAlreadyFullViewport ? 4 : 0,
                lg: props?.isAlreadyFullViewport ? 6 : 0
            }
        },
        tabPanel: {
            padding: { base: 0 }
        },
        tab: {
            fontSize: { base: 'sm' },
            fontWeight: { base: 'medium' },
            lineHeight: { base: '100%' },
            padding: '0 0 4px',
            marginRight: { base: 4, lg: 5 },
            color: 'black',
            _active: {
                backgroundColor: 'white'
            }
        }
    })
}
